import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.207 11.207a4.536 4.536 0 0 0-6.414-6.414l-.5.5a1 1 0 0 0 1.414 1.414l.5-.5a2.536 2.536 0 0 1 3.586 3.586l-3 3c-.99.99-2.596.99-3.586 0a1 1 0 0 0-1.414 1.414 4.536 4.536 0 0 0 6.414 0z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.207 11.207a1 1 0 0 0 0-1.414 4.536 4.536 0 0 0-6.414 0l-3 3a4.536 4.536 0 1 0 6.414 6.414l.5-.5a1 1 0 0 0-1.414-1.414l-.5.5a2.536 2.536 0 1 1-3.586-3.586l3-3c.99-.99 2.596-.99 3.586 0a1 1 0 0 0 1.414 0",
      clipRule: "evenodd"
    }
  )
);
var SvgLinkOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LinkOutlined_default = SvgLinkOutlined;

export { LinkOutlined_default as default };
